module.exports = __webpack_public_path__ + "assets/img/e264-ml.svg";